var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06672 1.42525C8.39554 0.570772 9.60446 0.570773 9.93328 1.42525L11.5345 5.58617C11.6761 5.95421 12.0208 6.20465 12.4146 6.22561L16.8667 6.46265C17.7809 6.51133 18.1545 7.66109 17.4435 8.23786L13.981 11.0465C13.6747 11.2949 13.5431 11.7001 13.6448 12.0811L14.7952 16.3886C15.0314 17.2731 14.0533 17.9837 13.2851 17.4857L9.54394 15.0606C9.21303 14.8461 8.78697 14.8461 8.45606 15.0606L4.71493 17.4857C3.94666 17.9837 2.96862 17.2731 3.20485 16.3886L4.35517 12.0811C4.45692 11.7001 4.32526 11.2949 4.019 11.0465L0.556524 8.23786C-0.154519 7.66109 0.219062 6.51133 1.13333 6.46265L5.5854 6.22561C5.97919 6.20465 6.32389 5.95421 6.46551 5.58617L8.06672 1.42525Z",
    fill: "#97B6CF",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarImg);
export default __webpack_public_path__ + "static/media/star-img.44037c09cebae5ec5216ee521d53b4ba.svg";
export { ForwardRef as ReactComponent };